enum SectionTypes {
  Innovation,
  Intelligence,
  Method,
  Story,
}

export default SectionTypes;
